import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowCenter: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-arrow-center, resize big, box, arrow"><path d="M20.25 13.25V3.75L3.75 3.75L3.75 20.25H13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.75 15.25V9.75H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.27 10.2695L18.0001 17.9996" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareArrowCenter;
